/* eslint-disable no-empty */

import { LoanStatus } from '../../../components/Accounts/AccountFilterForm';
import { VegaRadioOption } from '../../../components/common/VegaRadioGroup';
import VegaSelect from '../../../components/common/VegaSelect';
import VegaSelectWithCheckbox from '../../../components/common/VegaSelectWithCheckbox';
import { toLowerCase } from '../../../constants/commonFunction';

interface IProps {
  selected: any;
  handleChange: (value: string) => void;
  handleDelete?: (index: number) => void;
  label?: string;
  disabled?: boolean;
  isMultiSelect?: boolean;
}

const LoanAccountSelector = ({
  selected,
  handleChange,
  handleDelete,
  isMultiSelect = false,
  label,
  disabled,
}: IProps) => {
  const onChange = (value: string) => {
    handleChange(value);
  };

  return (
    <>
      {!isMultiSelect ? (
        <VegaSelect
          ignoreLodash
          placeholder={label ?? 'Select Region'}
          options={getLoanStatusOption()}
          onChange={e => onChange(e.target.value)}
          value={selected}
          disabled={disabled}
        />
      ) : (
        <VegaSelectWithCheckbox
          options={getLoanStatusOption()}
          onSelect={selected => onChange(selected)}
          handleDelete={handleDelete}
          selected={selected}
          disabled={disabled}
        />
      )}
    </>
  );
};

export default LoanAccountSelector;
const getLoanStatusOption = () => {
  const options = Object.keys(LoanStatus).map(
    (comparison: string, index: number) => {
      const comparisonType = Object.values(LoanStatus)[index];
      return {
        label: toLowerCase(comparison),
        value: comparisonType,
      } as VegaRadioOption;
    }
  );
  return options;
};
